import React from 'react';
import { Card } from './Card';
import { Legend } from '../Legend';
import { BubbleChart } from '../charts/BubbleChart';
import { ChartInput } from '../../model/ChartInput';
import { Information } from '../Information';
import { t } from '../../i18n';

const EmotionCard = ({ input }: Props) => {
  // const neutralColor = '#1ACBE6';
  // const happyColor = '#ACEAF7';
  // const surpriseColor = '#FF8744';
  // const angerColor = '#A162F7';
  // const sadColor = '#81E9B4';
  // const datasets = [
  //   { label: 'Neutral', data: [ { x: 0, y: 0, r: 40 } ], backgroundColor: neutralColor },
  //   { label: 'Happy', data: [ { x: 60, y: 0, r: 20 } ], backgroundColor: happyColor },
  //   { label: 'Surprise', data: [ { x: 10, y: 100, r: 20 } ], backgroundColor: surpriseColor },
  //   { label: 'Anger', data: [ { x: 50, y: 70, r: 15 } ], backgroundColor: angerColor },
  //   { label: 'Neutral', data: [ { x: 80, y: 100, r: 5 } ], backgroundColor: sadColor }
  // ];
  // const labels = [];
  return (
    <Card>
      <div className="card-body">
        <div className="row h-100">
          <div className="col-12 col-lg-6 order-2 order-lg-1">
            <div className="d-flex align-items-center">
                          <Information id="emotion" content={<h5 className="card-title d-inline-block mb-2 mb-lg-0">{t('cards.emotion')}</h5>} />
                          <Information id="emotion" showMore={true} className="ms-2" />
                        </div>
            <div className="d-lg-flex align-items-center h-100">
              <div className="d-lg-flex flex-lg-column mb-2 mb-lg-0">
                <Legend color={'info'} label={t('emotion.calm')} />
                <Legend color={'label-info'} label={t('emotion.happy')} />
                <Legend color={'warning'} label={t('emotion.surprise')} />
                <Legend color={'primary'} label={t('emotion.anger')} />
                <Legend color={'success'} label={t('emotion.sad')} />
                </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 order-1 order-lg-2">
            <BubbleChart datasets={input.datasets || []} labels={input.labels || []} />
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  input: ChartInput
}

export { EmotionCard };